import styled, { css } from 'styled-components';

import { HeaderProps } from '@components/header-form/types';
import { device } from '@styles/media';
import Link from 'next/link';

const MainHeader = styled.header`
  width: 100%;
  padding: 19.5px 0;
  background: ${({ theme }) => theme.tokens.gray[100]};
  position: fixed;
  @media ${device.mobile} {
    padding-top: 24px;
    height: 70px;
    position: static;

    ${({ layout }: HeaderProps) =>
      layout === 'signup' &&
      css`
        position: fixed;
        background: ${({ theme }) => theme.tokens.gray[100]};
        z-index: 100;
      `}
  }
`;

const WrapperHeader = styled.div`
  max-width: 1140px;
  margin: 0 auto;
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
  @media ${device.mobile} {
    justify-content: center;

    ${({ layout }: HeaderProps) =>
      layout === 'signup' &&
      css`
        justify-content: space-between;
      `}
  }
`;

const ContainerBack = styled.div``;

const Back = styled.span`
  cursor: pointer;
  @media ${device.mobile} {
    display: none;

    ${({ layout }: HeaderProps) =>
      layout === 'signup' &&
      css`
        display: initial;
        margin-left: 18px;
      `}
  }
`;

const Logo = styled.span`
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  max-width: 330px;
  text-align: center;

  @media ${device.mobile} {
    ${({ layout }: HeaderProps) =>
      layout === 'signup' &&
      css`
        img {
          display: none;
        }
      `}
  }
`;

const TitleForm = styled.span`
  display: none;
  @media ${device.mobile} {
    display: block;
    font-size: 16px;
    line-height: 21px;
  }
`;

const Right = styled.span`
  display: block;
  width: 140px;
  text-decoration: none;
  @media ${device.mobile} {
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: ${({ theme }) => theme.tokens.blue[800]};
    position: absolute;
    right: 28px;
    text-decoration: none;
  }
`;

const Help = styled.span<{ highlightSignIn?: boolean } & HeaderProps>`
  width: 140px;
  height: 50px;
  line-height: 50px;
  text-decoration: none;
  text-align: center;
  border: 1px solid ${({ theme }) => theme.tokens.blue[800]};
  border-radius: 25px;
  font-weight: normal;
  font-size: 14px;
  color: ${({ theme }) => theme.tokens.blue[800]};
  transition: background-color 0.1s ease-out;
  &:hover {
    background-color: ${({ theme }) => theme.tokens.blue[800]};
    border: 1px solid ${({ theme }) => theme.tokens.gray[100]};
    color: ${({ theme }) => theme.tokens.gray[100]};
  }
  &:active {
    background-color: ${({ theme }) => theme.tokens.gray[100]};
    border: 1px solid ${({ theme }) => theme.tokens.blue[800]};
    color: ${({ theme }) => theme.tokens.blue[800]};
  }

  ${({ highlightSignIn }) =>
    highlightSignIn &&
    css`
      background-color: ${({ theme }) => theme.tokens.blue[800]};
      color: ${({ theme }) => theme.tokens.gray[100]};
      :hover {
        border: 1px solid ${({ theme }) => theme.tokens.blue[800]};
        background-color: ${({ theme }) => theme.tokens.gray[100]};
        color: ${({ theme }) => theme.tokens.blue[800]};
      }
    `}
  @media ${device.mobile} {
    text-decoration: none;
    height: auto;
    border: none;
    position: absolute;
    right: 0;
    text-align: right;
    display: block;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: ${({ theme }) => theme.tokens.blue[800]};
    position: absolute;
    right: 12px;
    text-decoration: none;
    width: auto;
    &:hover {
      background: none;
      border: none;
      color: ${({ theme }) => theme.tokens.blue[800]};
    }
    &:active {
      background: none;
      border: none;
      color: ${({ theme }) => theme.tokens.blue[800]};
    }

    ${({ layout }: HeaderProps) =>
      layout === 'signup' &&
      css`
        padding: 7px 18px;
        background: ${({ theme }) => theme.tokens.gray[400]};
      `}

    ${({ highlightSignIn }) =>
      highlightSignIn &&
      css`
        background-color: ${({ theme }) => theme.tokens.blue[800]};
        color: ${({ theme }) => theme.tokens.gray[100]};
        :hover {
          border: 1px solid ${({ theme }) => theme.tokens.blue[800]};
          background-color: ${({ theme }) => theme.tokens.gray[100]};
          color: ${({ theme }) => theme.tokens.blue[800]};
        }
      `}
  }
`;

const LinkLogo = styled(Link)`
  height: 28px;
`;

export default {
  MainHeader,
  WrapperHeader,
  ContainerBack,
  Back,
  Logo,
  Right,
  Help,
  TitleForm,
  LinkLogo,
};
